/**
 * Shared countdown helpers for "next Monday midnight" (optimization update cycle).
 */

const MS_PER_MINUTE = 60 * 1000;
const MINUTES_PER_DAY = 60 * 24;

export const getNextMondayMidnight = () => {
  const now = new Date();
  const currentDay = now.getDay();
  const nextMonday = new Date(now);
  nextMonday.setHours(0, 0, 0, 0);
  let daysToAdd = (8 - currentDay) % 7;
  if (currentDay === 1 && (now.getHours() > 0 || now.getMinutes() > 0 || now.getSeconds() > 0)) {
    daysToAdd = 7;
  }
  nextMonday.setDate(nextMonday.getDate() + daysToAdd);
  return nextMonday;
};

/**
 * @param {Date} targetDate
 * @returns {{ days: number, hours: number, minutes: number, isComplete: boolean }}
 */
export const formatCountdown = (targetDate) => {
  const diff = targetDate - new Date();
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, isComplete: true };
  const totalMinutes = Math.floor(diff / MS_PER_MINUTE);
  return {
    days: Math.floor(totalMinutes / MINUTES_PER_DAY),
    hours: Math.floor((totalMinutes % MINUTES_PER_DAY) / 60),
    minutes: totalMinutes % 60,
    isComplete: false,
  };
};
